import { fetcher } from "@utils/fetcher";
import { IFetchOptions } from "itsf-ui-common";
import { ICancelBroadbandEligibility, IFeatureFlag } from "@modules/eirCustomersFacade/interfaces";
import { mapWithList } from "@utils/mapperUtils";
import { mapFeatureFlag } from "@modules/eirCustomersFacade/mappers/mapFeatureFlag";
import {
    getAppointmentListRoute,
    getAvailableAppointmentDateListRoute,
    getRecommendationBannerRoute,
    closeRecommendationBannerRoute,
    getCancelBroadbandEligibilityRoute,
    getFeatureFlagRoute,
    postCancelBroadbandRoute,
    patchUpdateAppointmentRoute,
    getRescheduleAppointmentEligibilityRoute,
} from "@api-routes/eirCustomersFacade";
import { mapCancelBroadbandEligibility } from "./mappers/mapCancelBroadbandEligibility";
import { mapAppointment } from "@modules/eirCustomersFacade/mappers/mapAppointment";
import { IAppointment } from "@modules/eirCustomersFacade/interfaces/models/IAppointment";
import { IAvailableAppointmentDate } from "@modules/eirCustomersFacade/interfaces/models/IAvailableAppointmentDate";
import { mapAvailableAppointmentDate } from "@modules/eirCustomersFacade/mappers/mapAvailableAppointmentDate";
import { IUpdateAppointmentPayload } from "@modules/eirCustomersFacade/interfaces/payloads/IUpdateAppointmentPayload";
import { mapRescheduleAppointmentEligibility } from "@modules/eirCustomersFacade/mappers/mapRescheduleAppointmentEligibility";
import { IRescheduleAppointmentEligibility } from "@modules/eirCustomersFacade/interfaces/models/IRescheduleAppointmentEligibility";

export const getFeatureFlagList = (options: IFetchOptions = {}) =>
    fetcher<IFeatureFlag[]>(getFeatureFlagRoute(), {
        ...options,
        mapper: mapWithList(mapFeatureFlag),
    });

export const getRecommendationBanner = (options: IFetchOptions = {}) =>
    fetcher<string>(getRecommendationBannerRoute(), {
        ...options,
    });

export const closeRecommendationBanner = (options: IFetchOptions = {}) =>
    fetcher<void>(closeRecommendationBannerRoute(), {
        ...options,
        method: "POST",
    });

export const getCancelBroadbandEligibility = (orderReference: string, options: IFetchOptions = {}) =>
    fetcher<ICancelBroadbandEligibility>(getCancelBroadbandEligibilityRoute(orderReference), {
        ...options,
        mapper: mapCancelBroadbandEligibility,
    });

export const postCancelBroadband = (orderReference: string, options: IFetchOptions = {}) =>
    fetcher<undefined>(postCancelBroadbandRoute(orderReference), {
        method: "POST",
        ...options,
    });

export const getAppointmentList = (options: IFetchOptions = {}) =>
    fetcher<IAppointment[]>(getAppointmentListRoute(), {
        ...options,
        mapper: mapWithList(mapAppointment),
    });

export const getAvailableAppointmentDateList = (appointmentId: number, options: IFetchOptions = {}) =>
    fetcher<IAvailableAppointmentDate[]>(getAvailableAppointmentDateListRoute(appointmentId), {
        ...options,
        mapper: mapWithList(mapAvailableAppointmentDate),
    });

export const getRescheduleAppointmentEligibility = (appointmentId: number, options: IFetchOptions = {}) =>
    fetcher<IRescheduleAppointmentEligibility>(getRescheduleAppointmentEligibilityRoute(appointmentId), {
        ...options,
        mapper: mapRescheduleAppointmentEligibility,
    });

export const patchUpdateAppointment = (
    appointmentId: number,
    payload: IUpdateAppointmentPayload,
    options: IFetchOptions = {}
) =>
    fetcher<void>(patchUpdateAppointmentRoute(appointmentId), {
        ...options,
        method: "PATCH",
        body: payload,
    });
